<nb-card class="col-12 " style="width:500px; min-height: 300px;">
  <nb-card-header>
  </nb-card-header>
  <nb-card-body>

    <div class="form-group">
      <label>Comments</label><br>
      <textarea [(ngModel)]="comments" name="comments" type="text" class="form-control" id="comments" rows="6"
        placeholder="Comments">
                        </textarea>
    </div>

    <div class="form-group">
      <button nbButton outline [disabled]="!comments" status="success" class="mr-2" (click)="submit()"><nb-icon
          icon="paper-plane-outline"></nb-icon> Save</button>
      <button nbButton outline status="info" (click)="cancel()"><nb-icon icon="close-square-outline"></nb-icon>
        Cancel</button>
    </div>

  </nb-card-body>
</nb-card>